import { render, staticRenderFns } from "./ImageCaptureItem.vue?vue&type=template&id=2fbb8cda&scoped=true&"
import script from "./ImageCaptureItem.vue?vue&type=script&lang=js&"
export * from "./ImageCaptureItem.vue?vue&type=script&lang=js&"
import style0 from "./ImageCaptureItem.vue?vue&type=style&index=0&id=2fbb8cda&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbb8cda",
  null
  
)

export default component.exports